export const MEMBERSHIP_TIERS = ['Discovery', 'Silver', 'Gold', 'Platinum', 'Diamond'];

export const getCurrentTierIndex = (userPoints, selectedRestaurant) => {
    // Sort tiers by their index to ensure proper sequential order
    const sortedTiers = selectedRestaurant.membershipTiers
        ?.sort((a, b) => a.index - b.index) || [];
    
    if (sortedTiers.length === 0) return 0; // Default to Discovery if no tiers
    
    // Find the current tier based on sequential progression
    let currentTierIndex = -1; // Start with no tier
    
    for (let i = 0; i < sortedTiers.length; i++) {
        const tier = sortedTiers[i];
        if (userPoints >= tier.checkinRequirement) {
            currentTierIndex = MEMBERSHIP_TIERS.indexOf(tier.tier);
        } else {
            break; // Stop at the first tier they don't qualify for
        }
    }
    
    // If no tier found, return 0 (Discovery tier)
    return currentTierIndex === -1 ? 0 : currentTierIndex;
};

export const getNextMembershipTier = (userPoints, selectedRestaurant) => {
    return selectedRestaurant.membershipTiers?.find(tier => 
        tier.checkinRequirement > (userPoints || 0)
    );
  };

  export const getCurrentMembershipTier = (name, restaurants, userMemberships) => {
    const userMembership = getUserMembership(name, userMemberships);
    if (!userMembership) return null;
    const thisRestaurant = restaurants.find((r) => r.name === name);
    return thisRestaurant?.membershipTiers.find(
      (tier) => tier.tier === userMembership.tier,
    );
  };

  const getUserMembership = (name, userMemberships) => {
    return userMemberships?.filter(
      (membership) => membership.restaurant === name,
    )[0];
  };
